'use strict';


app = window.app || {};
socket = window.socket;

(function () {
	var reconnecting = false;

	var ioParams = {
		reconnectionAttempts: config.maxReconnectionAttempts,
		reconnectionDelay: config.reconnectionDelay,
		transports: config.socketioTransports,
		path: config.relative_path + '/socket.io',
	};

	socket = io(config.websocketAddress, ioParams);

	var oEmit = socket.emit;
	socket.emit = function (event, data, callback) {
		if (typeof data === 'function') {
			callback = data;
			data = null;
		}
		if (typeof callback === 'function') {
			oEmit.apply(socket, [event, data, callback]);
			return;
		}

		return new Promise(function (resolve, reject) {
			oEmit.apply(socket, [event, data, function (err, result) {
				if (err) reject(err);
				else resolve(result);
			}]);
		});
	};

	if (parseInt(app.user.uid, 10) >= 0) {
		addHandlers();
	}

	function addHandlers() {
		socket.on('connect', onConnect);

		socket.on('reconnecting', function () {
			// Wait 2s before firing
			setTimeout(function () {
				if (socket.disconnected) {
					onReconnecting();
				}
			}, 2000);
		});

		socket.on('disconnect', onDisconnect);

		socket.on('reconnect_failed', function () {
			// Wait ten times the reconnection delay and then start over
			setTimeout(socket.connect.bind(socket), parseInt(config.reconnectionDelay, 10) * 10);
		});

		socket.on('checkSession', function (uid) {
			if (parseInt(uid, 10) !== parseInt(app.user.uid, 10)) {
				app.handleInvalidSession();
			}
		});

		socket.on('setHostname', function (hostname) {
			app.upstreamHost = hostname;
		});

		socket.on('event:banned', onEventBanned);
		socket.on('event:alert', function (params) {
			app.alert(params);
		});
		socket.on('event:deprecated_call', function (data) {
			console.warn('[socket.io] ', data.eventName, 'is now deprecated in favour of', data.replacement);
		});

		socket.removeAllListeners('event:nodebb.ready');
		socket.on('event:nodebb.ready', function (data) {
			if ((data.hostname === app.upstreamHost) && (!app.cacheBuster || app.cacheBuster !== data['cache-buster'])) {
				app.cacheBuster = data['cache-buster'];

				app.alert({
					alert_id: 'forum_updated',
					title: '[[global:updated.title]]',
					message: '[[global:updated.message]]',
					clickfn: function () {
						window.location.reload();
					},
					type: 'warning',
				});
			}
		});
		socket.on('event:livereload', function () {
			if (app.user.isAdmin && !ajaxify.currentPage.match(/admin/)) {
				window.location.reload();
			}
		});
	}

	function onConnect() {
		if (!reconnecting) {
			app.showMessages();
			$(window).trigger('action:connected');
		}

		if (reconnecting) {
			var reconnectEl = $('#reconnect');
			var reconnectAlert = $('#reconnect-alert');

			reconnectEl.tooltip('destroy');
			reconnectEl.html('<i class="fa fa-check"></i>');
			reconnectAlert.fadeOut(500);
			reconnecting = false;

			reJoinCurrentRoom();

			socket.emit('meta.reconnected');

			$(window).trigger('action:reconnected');

			setTimeout(function () {
				reconnectEl.removeClass('active').addClass('hide');
			}, 3000);
		}
	}

	function reJoinCurrentRoom() {
		var	url_parts = window.location.pathname.slice(config.relative_path.length).split('/').slice(1);
		var room;

		switch (url_parts[0]) {
			case 'user':
				room = 'user/' + (ajaxify.data ? ajaxify.data.theirid : 0);
				break;
			case 'topic':
				room = 'topic_' + url_parts[1];
				break;
			case 'category':
				room = 'category_' + url_parts[1];
				break;
			case 'recent':
				room = 'recent_topics';
				break;
			case 'unread':
				room = 'unread_topics';
				break;
			case 'popular':
				room = 'popular_topics';
				break;
			case 'admin':
				room = 'admin';
				break;
			case 'categories':
				room = 'categories';
				break;
		}
		app.currentRoom = '';
		app.enterRoom(room);
	}

	function onReconnecting() {
		reconnecting = true;
		var reconnectEl = $('#reconnect');
		var reconnectAlert = $('#reconnect-alert');

		if (!reconnectEl.hasClass('active')) {
			reconnectEl.html('<i class="fa fa-spinner fa-spin"></i>');
			reconnectAlert.fadeIn(500).removeClass('hide');
		}

		reconnectEl.addClass('active').removeClass('hide').tooltip({
			placement: 'bottom',
		});
	}

	function onDisconnect() {
		$(window).trigger('action:disconnected');
	}

	/** 
	 * 和PHP一样的时间戳格式化函数 
	 * @param {string} format 格式 
	 * @param {int} timestamp 要格式化的时间 默认为当前时间 
	 * @return {string}   格式化的时间字符串 
	 * dateString('Y-m-d H:i:s','1350052653');
	 */
	function dateString(format, timestamp) {
		var pad = function (n, c) {
			if ((n = n + "").length < c) {
				return new Array(++c - n.length).join("0") + n;
			} else {
				return n;
			}
		};
		var padRight = function (n, c) {
			if ((n = n + "").length < c) {
				return n + (new Array(++c - n.length).join("0"));
			} else {
				return n;
			}
		};
		var a, jsdate = ((timestamp) ? new Date(parseInt(padRight(timestamp, 13))) : new Date());
		var txt_weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
		var txt_ordin = { 1: "st", 2: "nd", 3: "rd", 21: "st", 22: "nd", 23: "rd", 31: "st" };
		var txt_months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
		var f = {
			// Day 
			d: function () { return pad(f.j(), 2) },
			D: function () { return f.l().substr(0, 3) },
			j: function () { return jsdate.getDate() },
			l: function () { return txt_weekdays[f.w()] },
			N: function () { return f.w() + 1 },
			S: function () { return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th' },
			w: function () { return jsdate.getDay() },
			z: function () { return (jsdate - new Date(jsdate.getFullYear() + "/1/1")) / 864e5 >> 0 },

			// Week 
			W: function () {
				var a = f.z(), b = 364 + f.L() - a;
				var nd2, nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1;
				if (b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b) {
					return 1;
				} else {
					if (a <= 2 && nd >= 4 && a >= (6 - nd)) {
						nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31");
						return date("W", Math.round(nd2.getTime() / 1000));
					} else {
						return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0);
					}
				}
			},

			// Month 
			F: function () { return txt_months[f.n()] },
			m: function () { return pad(f.n(), 2) },
			M: function () { return f.F().substr(0, 3) },
			n: function () { return jsdate.getMonth() + 1 },
			t: function () {
				var n;
				if ((n = jsdate.getMonth() + 1) == 2) {
					return 28 + f.L();
				} else {
					if (n & 1 && n < 8 || !(n & 1) && n > 7) {
						return 31;
					} else {
						return 30;
					}
				}
			},

			// Year 
			L: function () { var y = f.Y(); return (!(y & 3) && (y % 1e2 || !(y % 4e2))) ? 1 : 0 },
			//o not supported yet 
			Y: function () { return jsdate.getFullYear() },
			y: function () { return (jsdate.getFullYear() + "").slice(2) },

			// Time 
			a: function () { return jsdate.getHours() > 11 ? "pm" : "am" },
			A: function () { return f.a().toUpperCase() },
			B: function () {
				// peter paul koch: 
				var off = (jsdate.getTimezoneOffset() + 60) * 60;
				var theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off;
				var beat = Math.floor(theSeconds / 86.4);
				if (beat > 1000) beat -= 1000;
				if (beat < 0) beat += 1000;
				if ((String(beat)).length == 1) beat = "00" + beat;
				if ((String(beat)).length == 2) beat = "0" + beat;
				return beat;
			},
			g: function () { return jsdate.getHours() % 12 || 12 },
			G: function () { return jsdate.getHours() },
			h: function () { return pad(f.g(), 2) },
			H: function () { return pad(jsdate.getHours(), 2) },
			i: function () { return pad(jsdate.getMinutes(), 2) },
			s: function () { return pad(jsdate.getSeconds(), 2) },
			//u not supported yet 

			// Timezone 
			//e not supported yet 
			//I not supported yet 
			O: function () {
				var t = pad(Math.abs(jsdate.getTimezoneOffset() / 60 * 100), 4);
				if (jsdate.getTimezoneOffset() > 0) t = "-" + t; else t = "+" + t;
				return t;
			},
			P: function () { var O = f.O(); return (O.substr(0, 3) + ":" + O.substr(3, 2)) },
			//T not supported yet 
			//Z not supported yet 

			// Full Date/Time 
			c: function () { return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P() },
			//r not supported yet 
			U: function () { return Math.round(jsdate.getTime() / 1000) }
		};

		return format.replace(/[\\]?([a-zA-Z])/g, function (t, s) {
			if (t != s) {
				// escaped 
				ret = s;
			} else if (f[s]) {
				// a date function exists 
				ret = f[s]();
			} else {
				// nothing special 
				ret = s;
			}
			return ret;
		});
	}

	//dateFormat(11111111111111, 'Y年m月d日 H时i分')
	function dateFormat(timestamp, formats) {
		// formats格式包括
		// 1. Y-m-d
		// 2. Y-m-d H:i:s
		// 3. Y年m月d日
		// 4. Y年m月d日 H时i分
		formats = formats || 'Y-m-d';

		var padRight = function (n, c) {
			if ((n = n + "").length < c) {
				return n + (new Array(++c - n.length).join("0"));
			} else {
				return n;
			}
		};
		var zero = function (value) {
			if (value < 10) {
				return '0' + value;
			}
			return value;
		};

		var myDate = timestamp ? new Date(parseInt(padRight(timestamp, 13))) : new Date();

		var year = myDate.getFullYear();
		var month = zero(myDate.getMonth() + 1);
		var day = zero(myDate.getDate());

		var hour = zero(myDate.getHours());
		var minite = zero(myDate.getMinutes());
		var second = zero(myDate.getSeconds());

		return formats.replace(/Y|m|d|H|i|s/ig, function (matches) {
			return ({
				Y: year,
				m: month,
				d: day,
				H: hour,
				i: minite,
				s: second
			})[matches];
		});
	}

	function dateDiff(timestamp) {
		// 补全为13位
		var arrTimestamp = (timestamp + '').split('');
		for (var start = 0; start < 13; start++) {
			if (!arrTimestamp[start]) {
				arrTimestamp[start] = '0';
			}
		}
		timestamp = arrTimestamp.join('') * 1;

		var minute = 1000 * 60;
		var hour = minute * 60;
		var day = hour * 24;
		var halfamonth = day * 15;
		var month = day * 30;
		var now = new Date().getTime();
		var diffValue = now - timestamp;

		// 如果本地时间反而小于变量时间
		if (diffValue < 0) {
			return '不久前';
		}

		// 计算差异时间的量级
		var monthC = diffValue / month;
		var weekC = diffValue / (7 * day);
		var dayC = diffValue / day;
		var hourC = diffValue / hour;
		var minC = diffValue / minute;

		// 数值补0方法
		var zero = function (value) {
			if (value < 10) {
				return '0' + value;
			}
			return value;
		};

		// 使用
		if (monthC > 12) {
			// 超过1年，直接显示年月日
			return (function () {
				var date = new Date(timestamp);
				return date.getFullYear() + '年' + zero(date.getMonth() + 1) + '月' + zero(date.getDate()) + '日';
			})();
		} else if (monthC >= 1) {
			return parseInt(monthC) + "月前";
		} else if (weekC >= 1) {
			return parseInt(weekC) + "周前";
		} else if (dayC >= 1) {
			return parseInt(dayC) + "天前";
		} else if (hourC >= 1) {
			return parseInt(hourC) + "小时前";
		} else if (minC >= 1) {
			return parseInt(minC) + "分钟前";
		}
		return '刚刚';
	}

	function onEventBanned(data) {
		console.log(data);
		var message = data.until ? '[[error:user-banned-reason-until, ' + dateFormat(data.until, 'Y-m-d H:i:s') + ', ' + data.reason + ']]' : '[[error:user-banned-reason, ' + data.reason + ']]';

		bootbox.alert({
			title: '[[error:user-banned]]',
			message: message,
			closeButton: false,
			callback: function () {
				window.location.href = config.relative_path + '/';
			},
		});
	}

	if (
		config.socketioOrigins &&
		config.socketioOrigins !== '*:*' &&
		config.socketioOrigins.indexOf(location.hostname) === -1
	) {
		console.error(
			'You are accessing the forum from an unknown origin. This will likely result in websockets failing to connect. \n' +
			'To fix this, set the `"url"` value in `config.json` to the URL at which you access the site. \n' +
			'For more information, see this FAQ topic: https://community.nodebb.org/topic/13388'
		);
	}
}());
